<template>
  <div class="">
    <h1>ساعات کاری</h1>
    <div v-for="(workTimesItem,workTimeIndex) in workTimes">
      <h5>{{ daysNames[workTimeIndex] }}</h5>
      <div class="text-left">
        <b-btn variant="info" @click="addItemToWorkTimes(workTimeIndex)">
          اضافه کردن
          <b-icon-plus-circle-dotted class="h4"/>
        </b-btn>
      </div>
      <div v-for="(item,dayItemIndex) in workTimesItem">
        <hour-work-time-item @remove="refreshComponent" :work-time-item="item" :work-times="workTimes"
                             :day-index="workTimeIndex"
                             :day-item-index="dayItemIndex" class="my-3"/>
      </div>
    </div>
  </div>
</template>

<script>
import HourWorkTimeItem from "./HourWorkTimeItem.vue";

export default {
  name: "HourReservationWorkTimes",
  components: {HourWorkTimeItem},
  data() {
    return {
      daysNames: [
        'یکشنبه',
        'دوشنبه',
        'سه شنبه',
        'چهار شنبه',
        'پنج شنبه',
        'جمعه',
        'شنبه',
      ]
    }
  },
  props: {
    reservation: {}
  },
  computed: {
    workTimes() {
      return this.reservation.reservationRule.work_times
    }
  },
  methods: {
    addItemToWorkTimes(dayIndex) {
      this.workTimes[dayIndex].push(['10:00', '11:00'])
      this.refreshComponent()
    },
    refreshComponent() {
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>

</style>